/* Shared V8.0 review UI. Persistence and cart operations belong exclusively to FantastickJourney. */
(function (w) {
  'use strict';
  if (w.FantastickJourneyView) return;
  const owners = new Map();
  const node = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  function mount(root, config, callbacks = {}) {
    const J = w.FantastickJourney, q = key => root.querySelector('[data-fkw-' + key + ']');
    const removers = [], urls = [];
    let id = '', busy = false, destroyed = false;
    const on = (target, event, fn) => { if (target) { target.addEventListener(event, fn); removers.push(() => target.removeEventListener(event, fn)); } };
    const status = callbacks.status || ((text, error) => { q('status').textContent = text || ''; q('status').classList.toggle('is-error', !!error); });
    function release() { urls.splice(0).forEach(url => URL.revokeObjectURL(url)); }
    function lock(value) { busy = value; ['cart', 'discard'].forEach(key => { if (q(key)) q(key).disabled = value; }); if (callbacks.lock) callbacks.lock(value); }
    function money(value, currency) { return new Intl.NumberFormat(config.locale || 'de', { style: 'currency', currency }).format(value / 100); }
    function belongs(set) { return J.localURL(set.worldUrl).pathname === w.location.pathname && (!set.entrySectionId || String(set.entrySectionId) === String(config.sectionId)); }
    async function review(setId, moveFocus = true) {
      const set = await J.load(setId);
      if (destroyed || !belongs(set)) return;
      if (owners.has(setId) && owners.get(setId) !== root) return;
      owners.set(setId, root); id = setId; release();
      if (callbacks.beforeReview) callbacks.beforeReview();
      q('browse').hidden = true; q('resume').hidden = true; q('review').hidden = false;
      const list = q('review-items'); list.replaceChildren();
      set.items.forEach(item => {
        const card = node('article', 'fkw__review-item'), body = node('div'); let image = item.product.imageUrl;
        if (item.draft && item.draft.preview) { image = URL.createObjectURL(item.draft.preview); urls.push(image); }
        if (image) { const img = node('img'); img.src = image; img.alt = 'Vorschau: ' + item.product.title; img.loading = 'lazy'; card.append(img); } else card.append(node('div'));
        body.append(node('h4', '', item.product.title));
        if (item.draft) {
          body.append(node('strong', '', money(item.draft.price, set.currency)));
          const values = node('ul');
          Object.entries(item.draft.properties).filter(([key]) => !key.startsWith('_')).forEach(([key, value]) => values.append(node('li', '', key + ': ' + value)));
          body.append(values);
        }
        if (item.status === 'added') body.append(node('p', '', '✓ Bereits im Warenkorb'));
        else if (['sending', 'uncertain'].includes(item.status)) body.append(node('p', '', 'Übertragung unklar – bitte Warenkorb prüfen.'));
        else { const a = node('a', '', item.draft ? 'Bearbeiten' : 'Jetzt gestalten'); a.href = J.editorURL(set, item); body.append(a); }
        card.append(body); list.append(card);
      });
      const complete = set.items.every(item => !!item.draft);
      q('total').textContent = (complete ? 'Artikelsumme: ' : 'Bereits gestaltete Artikel: ') + money(set.items.reduce((sum, item) => sum + (item.draft ? item.draft.price : 0), 0), set.currency);
      q('cart').textContent = set.items.some(item => ['sending', 'uncertain', 'added'].includes(item.status)) ? 'Warenkorb prüfen & fortfahren' : 'Alle Produkte in den Warenkorb';
      q('cart').disabled = !complete || busy || set.currency !== config.currency;
      if (set.currency !== config.currency) status('Die Shop-Währung hat sich geändert. Bitte starte eine neue Auswahl in der aktuellen Währung.', true);
      if (moveFocus) { const h = q('review').querySelector('h3'); h.focus({ preventScroll: true }); h.scrollIntoView({ block: 'start', behavior: 'auto' }); }
    }
    on(q('cart'), 'click', async () => {
      if (busy || !id) return; lock(true);
      try { await J.checkout(id, config, message => { if (!destroyed) status(message); }); }
      catch (error) { if (destroyed) return; lock(false); await review(id, false).catch(() => {}); status(error.message, true); q('status').focus({ preventScroll: true }); }
    });
    on(q('discard'), 'click', async () => {
      if (busy || !id) return;
      try {
        await J.discard(id); if (destroyed) return; owners.delete(id); id = ''; release();
        q('review').hidden = true; q('browse').hidden = false;
        const u = J.localURL(w.location.href); ['fkc_set', 'fkc_entry'].forEach(key => u.searchParams.delete(key)); u.hash = ''; w.history.replaceState(null, '', u.href);
        status('Die gespeicherte Auswahl wurde verworfen. Bereits hinzugefügte Artikel bleiben im Warenkorb.');
        if (callbacks.afterDiscard) callbacks.afterDiscard();
      } catch (error) { if (!destroyed) status(error.message, true); }
    });
    on(w, 'pageshow', event => { if (event.persisted) { lock(false); if (id) review(id, false).catch(error => { if (!destroyed) status(error.message, true); }); } });
    async function init() {
      if (config.designMode) return;
      const p = new URLSearchParams(w.location.search), requested = p.get('fkc_set');
      if (p.get('fkc_entry') && p.get('fkc_entry') !== String(config.sectionId)) return;
      if (requested) { try { await review(requested); } catch (error) { if (!destroyed) status(error.message, true); } }
      else if (J.current()) {
        try {
          const set = await J.load(J.current()); if (destroyed || set.completed || !belongs(set)) return;
          const resume = q('resume'); resume.hidden = false; resume.replaceChildren(node('p', '', 'Deine Produktauswahl wartet auf dich.'));
          const button = node('button', 'fkw__secondary', 'Auswahl fortsetzen'); button.type = 'button'; resume.append(button);
          on(button, 'click', () => review(set.id).catch(error => status(error.message, true)));
        } catch (_) { /* No usable local set. */ }
      }
    }
    return { init, review, destroy() { destroyed = true; release(); if (owners.get(id) === root) owners.delete(id); removers.forEach(remove => remove()); } };
  }
  w.FantastickJourneyView = { mount };
})(window);
